import { NgModule } from '@angular/core';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';

@NgModule({
    imports: [BgContrastDirective, GridModule],
    exports: [BgContrastDirective, GridModule]
})
export class AtomicModule {}
